import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

import "../css-coding/ServiceSlider2.css";

import img1 from "../assets/service1.png";
import img2 from "../assets/service2.png";
import img3 from "../assets/service3.png";
import img4 from "../assets/service4.png";
import img5 from "../assets/service5.png";
import img6 from "../assets/service6.png";

const services = [
  {
    title: "Video Editing",
    desc: "We’ll take care of turning your raw clips into high quality, storytelling content that captures attention and drives results.",
    img: img5,
  },
  {
    title: "Personal Branding",
    desc: "We handle everything from ideation to execution, crafting content that builds consistency, community, and brand credibility.",
    img: img1,
  },
  {
    title: "Social Media Managing",
    desc: "We’ll manage your Instagram and YouTube with bio optimization, content scheduling, and engagement strategies that convert.",
    img: img3,
  },
  {
    title: "Graphic Designing",
    desc: "We design with intent, ensuring every visual delivers clarity, creativity, and a consistent brand experience.",
    img: img6,
  },
  {
    title: "Web Designing",
    desc: "We’ll take care of building a visually stunning, high-performing website that’s optimized for both users and conversions.",
    img: img2,
  },
  {
    title: "Shooting",
    desc: "We handle personal and commercial shoots, delivering cinematic frames that showcase your brand’s personality and power.",
    img: img4,
  },
];

export default function ServiceSlider2() {
  const swiperRef = useRef(null);

  return (
    <div className="service-slider-section-ss2">
      <p className="section-label-ss2">• Services</p>

      <h2 className="slider-heading-ss2">
        Creative, Consistent and Reliable Solutions{" "}
        <span className="desktop-break-ss2"><br /></span>
        to grow your Brand
      </h2>

      <div className="slider-wrapper-ss2">
        <button
          className="arrow-btn-ss2 left-ss2"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          ❮
        </button>

        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          speed={1000}
          loop={true}
          coverflowEffect={{
            rotate: -6.09,
            stretch: 0,
            depth: 200,
            modifier: 2,
            slideShadows: false,
          }}
          navigation={false}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 0 },
            768: { slidesPerView: 2, spaceBetween: 90 },
            992: { slidesPerView: 2, spaceBetween: 180 },
          }}
          modules={[EffectCoverflow, Navigation]}
          className="mySwiper-ss2"
        >
          {services.map((service, index) => (
            <SwiperSlide key={index} className="service-slide-ss2">
              <img src={service.img} alt={service.title} />

              <div className="slide-content-ss2">
                <h4>{service.title}</h4>
                <p>{service.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <button
          className="arrow-btn-ss2 right-ss2"
          onClick={() => swiperRef.current?.slideNext()}
        >
          ❯
        </button>
      </div>
    </div>
  );
}
